import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL ?? 'https://placeholder.supabase.co'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY ?? 'placeholder'

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true
  },
  db: {
    schema: 'johnnyvaz'
  }
})

// Database Types
export interface Profile {
  id: string
  full_name?: string
  avatar_url?: string
  bio?: string
  created_at: string
  updated_at: string
}

export interface Ebook {
  id: string
  title: string
  description?: string
  cover_url?: string
  price: number
  total_chapters: number
  estimated_reading_time?: number
  created_at: string
  updated_at: string
}

export interface Chapter {
  id: string
  ebook_id: string
  chapter_number: number
  chapter_order: number
  title: string
  slug: string
  content?: string
  content_path?: string
  word_count?: number
  estimated_reading_time?: number
  is_published: boolean
  created_at: string
}

export interface EbookAccess {
  id: string
  user_id: string
  ebook_id: string
  purchased_at: string
  expires_at?: string
  payment_id?: string
}

export interface UserProgress {
  id: string
  user_id: string
  chapter_id: string
  progress_percentage: number
  completed: boolean
  reading_time_minutes: number
  last_read_at: string
  created_at: string
  updated_at: string
}

export interface Bookmark {
  id: string
  user_id: string
  chapter_id: string
  position_percentage: number
  note?: string
  created_at: string
}

export interface UserNote {
  id: string
  user_id: string
  chapter_id: string
  position_percentage: number
  selected_text?: string
  note_content: string
  created_at: string
  updated_at: string
}

export interface ReadingSettings {
  id: string
  user_id: string
  font_size: number
  font_family: string
  line_height: number
  text_align: string
  theme: string
  max_width: number
  auto_bookmark: boolean
  highlight_enabled: boolean
  created_at: string
  updated_at: string
}

export interface ReadingAnalytics {
  id: string
  user_id: string
  ebook_id: string
  chapter_id?: string
  event_type: string
  event_data?: Record<string, any>
  session_id?: string
  ip_address?: string
  user_agent?: string
  created_at: string
}

export interface Payment {
  id: string
  user_id: string
  ebook_id: string
  amount: number
  currency: string
  payment_method: 'stripe' | 'pix'
  payment_status: 'pending' | 'completed' | 'failed' | 'refunded'
  stripe_payment_intent_id?: string
  pix_code?: string
  pix_qr_code?: string
  metadata?: Record<string, any>
  created_at: string
  updated_at: string
}